import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

window.addEventListener('DOMContentLoaded', () => {

    const headerSliderContainers = document.querySelectorAll(
        '.swiper-container.header-slider'
    );

    headerSliderContainers.forEach((headerSliderContainer) => {
        const swiperID = headerSliderContainer.parentElement.getAttribute('data-swiperid');
        new Swiper(headerSliderContainer, {
            modules: [Pagination, Navigation],
            spaceBetween: 32,
            slidesPerView: 1,
            watchOverflow: true,
            centerInsufficientSlides: true,
            pagination: {
                el: `[data-swiperid="${swiperID}"] .swiper-pagination`,
                clickable: true,
            },
            navigation: {
                nextEl: headerSliderContainer.querySelector('.swiper-button-next'),
                prevEl: headerSliderContainer.querySelector('.swiper-button-prev'),
            },
        });
    });
});
